import React, { useState } from 'react';
import styled from 'styled-components';

import { CARD_TYPES } from '../../../shared/constants';
import { ICard, ITab } from '../../../types/shared';

import { DEQ_COMPS } from '../../../utils/deq';
import { ReactMarkdownExtended } from '../../../utils/generic';

import mq from '../../../styles/breakpoints';
import colors from '../../../styles/colors';
import { H2, SmallText } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import { WizardResultItem } from '../../../types/wizard';
import TabWrapperGeneric from '../../molecules/tab-wrapper/TabWrapperGeneric';

import { TabWrapperExtended } from './WizardResultLayout.types';
import WizardResultList from './WizardResultList';

export interface WizardTabWrapperProps {
  wrapper: TabWrapperExtended;
  results: WizardResultItem[];
  renderCardTitles: boolean;
}

const WizardTabWrapper = ({
  wrapper,
  results,
  ...props
}: WizardTabWrapperProps) => {
  const initialTab = wrapper.tabs[0];
  const [activeTab, setActiveTab] = useState<ITab>(initialTab);
  const parsedTabs = wrapper.tabs.map((tab) => ({
    ...tab,
    disabled: !results.find((result) => result.tabId === tab.id),
  }));
  const activeTabResults = results.filter(
    (result) => result.tabId === activeTab.id
  );

  // TODO: Refactor tab wrapper to contain logic inside the tab wrapper.
  return (
    <TabWrapperGeneric
      tabs={parsedTabs}
      activeTab={activeTab}
      onTabChange={(tab) => setActiveTab(tab)}
    >
      {activeTab?.body?.map((card, index) => {
        if (card.type === CARD_TYPES.header) {
          return (
            <TextWrapper key={index}>
              <StyledH2>{card.title}</StyledH2>
              <StyledSmallText>
                <ReactMarkdownExtended componentType={DEQ_COMPS.wizardTab}>
                  {(card as ICard).body.childMarkdownRemark.rawMarkdownBody}
                </ReactMarkdownExtended>
              </StyledSmallText>
            </TextWrapper>
          );
        }
      })}
      <WizardResultList results={activeTabResults} {...props} />
    </TabWrapperGeneric>
  );
};

const TextWrapper = styled.div`
  ${mq.to.breakpoint.M`
    display: block;
    margin: 0 ${Spacings.S};
  `}
`;

const StyledH2 = styled(H2)`
  margin-bottom: ${Spacings.XS};
`;

const StyledSmallText = styled(SmallText)`
  color: ${colors.abnNeutral500};
`;

export default WizardTabWrapper;
